<template>
	<div class="container">
		<!-- <div class="title">{{ $t("index.seventh.title") }}</div> -->
		<div class="video-container">
			<div v-if="!isPlaying" class="cover" @click="playVideo">
				<img :src="coverImage" alt="video cover" class="cover-image" />
				<span class="play-icon">▶</span>
			</div>
			<video v-if="isPlaying" ref="videoPlayer" :src="videoSrc" class="video-player" @ended="onVideoEnded" controls>
				<source type="video/mp4" />
				{{ $t("index.seventh.emptyInfo") }}
			</video>


			<div v-if="!isPlaying" class="video-info">
				02:26
			</div>
		</div>


	</div>
</template>

<script>
import videoCover from "@/assets/images/logo_slogan_.png"
export default {
	data() {
		return {
			lang: localStorage.getItem("lang") || 'zh',
			isPlaying: false,
			videoSrcEn: "/cstatic/contrimetric/public.mp4",
			videoSrcZh: '/cstatic/contrimetric/publicZh.mp4',
			coverImage: videoCover,
		}
	},
	computed: {
		videoSrc() {
			return this.lang === 'zh' ? this.videoSrcZh : this.videoSrcEn;
		}
	},
	mounted() {
	},
	methods: {
		playVideo() {
			this.isPlaying = true;
			this.$nextTick(() => {
				this.$refs.videoPlayer.play();
			});
		},
		onVideoEnded() {
			this.isPlaying = false;
		},

	}
}
</script>

<style lang="scss" scoped>
.container {
	.title {
		font-size: 30px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 50px;
	}

	.video-container {
		width: 100%;
		margin-top: 20px;
		position: relative;

		.cover {
			position: relative;
			cursor: pointer;
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 380px;
			transition: all .3s;
			padding: 80px;
			box-sizing: border-box;

			&:hover {
				cursor: pointer;
				opacity: 0.7;

				.play-icon {
					transform: scale(1.05);
				}
			}

			img {
				width: 100%;
				object-fit: contain;
			}
		}

		.cover-image {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.play-icon {
			position: absolute;
			font-size: 30px;
			color: white;
			z-index: 9;
			background-color: #00000087;
			padding: 10px;
			border-radius: 50%;
			width: 70px;
			height: 70px;
			box-sizing: border-box;
			display: flex;
			justify-content: center;
			align-items: center;
			transition: all .3s;
		}

		.video-player {
			width: 100%;
			height: auto;
			transform: translateZ(0);
		}

		.video-info {
			position: absolute;
			background: linear-gradient(to bottom, rgb(255 255 255 / 0%), rgb(0 0 0 / 55%));
			width: 100%;
			height: 60px;
			color: white;
			bottom: 0;
			display: flex;
			justify-content: flex-end;
			align-items: center;
			padding-right: 20px;
			box-sizing: border-box;
		}
	}

}
</style>